export default __webpack_public_path__ + "static/media/settings.ff7c3425.svg";